import { ITranslations } from 'types/common';
import en from 'translations/en/translationsForMobileForm.json';
import pl from 'translations/pl/translationsForMobileForm.json';
import sl from 'translations/sl/translationsForMobileForm.json';
import { TranslationsForMobileFormTransFields } from './types';

export const TranslationsForMobileFormTranslations: ITranslations<TranslationsForMobileFormTransFields> = {
  name: 'translationsForMobileForm',
  en,
  pl,
  sl,
};
